module.exports = __webpack_public_path__ + "static/media/theme1.59274e04.png";